var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileBlueIconUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#ECEFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4012_50290",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4012_50290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8366 23.8359H14.6699C14.2116 23.8359 13.8192 23.6727 13.4928 23.3464C13.1664 23.02 13.0033 22.6276 13.0033 22.1693V10.5026C13.0033 10.0443 13.1664 9.65191 13.4928 9.32552C13.8192 8.99913 14.2116 8.83594 14.6699 8.83594H20.5033L25.5033 13.8359V22.1693C25.5033 22.6276 25.3401 23.02 25.0137 23.3464C24.6873 23.6727 24.2949 23.8359 23.8366 23.8359ZM19.6699 14.6693V10.5026H14.6699V22.1693H23.8366V14.6693H19.6699ZM11.3366 27.1693C10.8783 27.1693 10.4859 27.0061 10.1595 26.6797C9.83312 26.3533 9.66992 25.9609 9.66992 25.5026V13.8359H11.3366V25.5026H20.5033V27.1693H11.3366Z",
    fill: "#362689"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBlueIconUpload);
export default __webpack_public_path__ + "static/media/file-blue-icon-upload.5ae6cef70e57d70cd0908fc47e956f4f.svg";
export { ForwardRef as ReactComponent };